import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { class: "ss-tela-conteudo" }
const _hoisted_7 = { class: "ss-card ss-card-space" }
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1)
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-19" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Filtrar", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_produto = _resolveComponent("selecionar-tipo-produto")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: "MAPA_ESTOQUES",
          tituloRecurso: "Mapa dos Estoques",
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, null, 8, ["empresasSelecionadas"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_selecionar_empresa, {
                  codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                  "onUpdate:codigosSelecionados": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                  varias: true,
                  onChange: _ctx.atualizarSelecaoEmpresas
                }, null, 8, ["codigosSelecionados", "onChange"])
              ])
            ]),
            _createVNode(_component_a_form, {
              class: "ss-alinhar-texto-esquerda",
              layout: "vertical"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_card, {
                      titulo: "ESTOQUES",
                      style: {"height":"94%"},
                      class: "ss-padding-separacao-direita"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_tree, {
                          "tree-data": _ctx.treeData,
                          "show-icon": "",
                          expandedKeys: _ctx.state.estoquesExpandidos,
                          "onUpdate:expandedKeys": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.estoquesExpandidos) = $event)),
                          selectedKeys: _ctx.state.estoquesSelecionados,
                          "onUpdate:selectedKeys": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.estoquesSelecionados) = $event))
                        }, {
                          icon: _withCtx(({ disabled }) => [
                            (disabled === false)
                              ? (_openBlock(), _createBlock(_component_icone, {
                                  key: 0,
                                  nome: "estoque"
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["tree-data", "expandedKeys", "selectedKeys"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_card, {
                      titulo: "FILTROS",
                      class: "ss-padding-separacao-esquerda"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_a_form_item, {
                              label: "Produtos",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_produto, {
                                  codigosSelecionados: _ctx.state.parametrosConsulta.produtosDefinicoes,
                                  "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.parametrosConsulta.produtosDefinicoes) = $event)),
                                  varios: true,
                                  modoDefinicaoProduto: true,
                                  empresas: _ctx.telaBase.empresasSelecionadas,
                                  apresentarCodigoInterno: true,
                                  placeholder: 'Digite o código interno, código de barras, código personalizado ou descrição do produto...',
                                  limparSelecao: false,
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigosSelecionados", "empresas", "placeholder", "onChange"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipos de Produtos",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_produto, {
                                  codigosSelecionados: _ctx.state.parametrosConsulta.tiposProdutos,
                                  "onUpdate:codigosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.parametrosConsulta.tiposProdutos) = $event)),
                                  varios: true,
                                  placeholder: "Todos",
                                  limparSelecao: false,
                                  onChange: _ctx.limparInformacoesBusca
                                }, null, 8, ["codigosSelecionados", "onChange"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_a_form_item, {
                              label: "Utilizadores",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_pessoa, {
                                  codigosSelecionados: _ctx.state.parametrosConsulta.utilizadores,
                                  "onUpdate:codigosSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.parametrosConsulta.utilizadores) = $event)),
                                  varios: true,
                                  empresas: _ctx.telaBase.empresasSelecionadas
                                }, null, 8, ["codigosSelecionados", "empresas"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_checkbox, {
                                  checked: _ctx.state.parametrosConsulta.filtrarTodosEstoques,
                                  "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.parametrosConsulta.filtrarTodosEstoques) = $event)),
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.prepararFiltroEstoque($event)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Filtrar em todos estoques ")
                                  ]),
                                  _: 1
                                }, 8, ["checked"])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_form_item, {
                              label: " ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "ant-btn ant-btn-primary ant-btn-block",
                                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.consultaEstoque && _ctx.consultaEstoque(...args)))
                                }, _hoisted_22)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, {
                      titulo: "PRODUTOS ENCONTRADOS",
                      class: "ss-padding-separacao-esquerda"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_a_table, {
                          key: _ctx.state.controleResultado,
                          columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                          "data-source": _ctx.state.produtos,
                          rowKey: "codigo",
                          scroll: { x: 1500 },
                          pagination: false,
                          loading: _ctx.gradeBase.buscandoDados,
                          size: "small"
                        }, {
                          bodyCell: _withCtx(({ column, record }) => [
                            (column.key === 'Quantidade')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, record.casasDecimais)), 1))
                              : (column.key === 'QuantidadeBloqueada')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidadeBloqueada, record.casasDecimais)), 1))
                                : _createCommentVNode("", true)
                          ]),
                          emptyText: _withCtx(() => [
                            _createVNode(_component_mensagem_sem_dados, {
                              resultadoPesquisa: true,
                              mensagem: _ctx.preparaMensagemGrade()
                            }, null, 8, ["mensagem"])
                          ]),
                          _: 1
                        }, 8, ["columns", "data-source", "loading"]))
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}